import * as React from "react";
import { Eye, EyeOff } from "lucide-react";
import { IconButton } from "./icon-button";
import { cn } from "@/lib/utils";
import { useI18n } from "../../i18n";

/**
 * Who sees a journal record — ONE icon that is the state (owner 30.10: «почему просто не 2 иконки?»): `Eye` — the
 * players see it, `EyeOff` in the warn colour — hidden from them. The same everywhere a record shows its visibility
 * (the table's Journal, the Library of the rail, the record's header). The hint says the state and what a click does;
 * a click hides at once, or asks the host to show (widening is confirmed by the host's dialog).
 */
export function VisibilityToggle({
  shown,
  onToggle,
  size = "sm",
  disabled,
  className,
  testid,
}: {
  readonly shown: boolean;
  /** shown → hide (no question); hidden → the host asks «Показать игрокам?» before it sends. */
  readonly onToggle: () => void;
  readonly size?: "md" | "sm";
  readonly disabled?: boolean;
  readonly className?: string;
  readonly testid?: string;
}): React.JSX.Element {
  const { t } = useI18n();
  const words = t(shown ? "sb.journal.shownToggle" : "sb.journal.hiddenToggle");
  return (
    <IconButton
      size={size}
      label={words}
      icon={shown ? <Eye size={14} aria-hidden="true" /> : <EyeOff size={14} aria-hidden="true" />}
      data-testid={testid}
      data-state={shown ? "shown" : "hidden"}
      disabled={disabled}
      className={cn(shown ? "text-muted-foreground" : "text-warn hover:text-warn", className)}
      onClick={(e) => {
        e.stopPropagation();
        onToggle();
      }}
    />
  );
}
